export type RecentlyViewedCreator = {
	influencerId: string;
	handle: string;
	displayName: string;
	avatarUrl: string | null;
};

type RecentlyViewedEntry = {
	creator: RecentlyViewedCreator;
	timestamp: string;
};

const storageKey = "RecentlyViewedCreators";
const maxEntries = 20;

/**
 * "Recently viewed" for the public ask-page redesign's "My Creators" hub —
 * client-side only (localStorage), following the exact pattern already used
 * in RecentAccountCompletions.ts. Works for anonymous visitors too, not just
 * signed-in users, which server-side storage tied to a user_id couldn't do —
 * satisfies the original "get back to ones you forgot" goal even pre-login.
 */
function readEntries(): RecentlyViewedEntry[] {
	try {
		const raw = localStorage.getItem(storageKey);
		if (!raw) return [];
		return JSON.parse(raw) as RecentlyViewedEntry[];
	} catch {
		return [];
	}
}

function writeEntries(entries: RecentlyViewedEntry[]): void {
	try {
		localStorage.setItem(storageKey, JSON.stringify(entries));
	} catch {
		// Ignore storage failures (private browsing, quota, blocked storage).
	}
}

export function saveRecentlyViewedCreator(creator: RecentlyViewedCreator): void {
	const deduped = readEntries().filter((e) => e.creator.handle !== creator.handle);
	const updated = [{ creator, timestamp: new Date().toISOString() }, ...deduped].slice(
		0,
		maxEntries,
	);
	writeEntries(updated);
}

export function getRecentlyViewedCreators(): RecentlyViewedCreator[] {
	return readEntries().map((e) => e.creator);
}

export function getRecentlyViewedCreatorEntries(): RecentlyViewedEntry[] {
	return readEntries();
}

export function clearRecentlyViewedCreators(): void {
	writeEntries([]);
}
